import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Button,
  Typography,
  Paper,
  Stack,
  useTheme,
  useMediaQuery,
} from "@mui/material";

const Layout = ({ loading, machineId }) => {
  const [isStreaming, setIsStreaming] = useState(false);
  const wsRef = useRef(null);
  const canvasRef = useRef(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const startStream = () => {
    if (!machineId) return;

    if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
      wsRef.current.send(JSON.stringify({ type: "control", command: "start", machineId }));
      return;
    }

    wsRef.current = new WebSocket("wss://pickaagosentry.duckdns.org:8080");

    wsRef.current.onopen = () => {
      console.log("WebSocket Connected for",machineId);

      wsRef.current.send(JSON.stringify({
        type: "register",
        role: "react",
        machineId,
      }));

      wsRef.current.send(JSON.stringify({
        type: "control",
        command: "start",
        machineId,
      }));

      console.log("Start signal sent for ",machineId);
    };

    wsRef.current.onmessage = (event) => {
      if (typeof event.data !== "string") {
        const blob = new Blob([event.data], { type: "image/jpeg" });
        const img = new Image();
        img.src = URL.createObjectURL(blob);
        img.onload = () => {
          const canvas = canvasRef.current;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          URL.revokeObjectURL(img.src);
        };
      }
    };

    wsRef.current.onerror = (err) => {
      console.error("WebSocket error:", err);
    };

    wsRef.current.onclose = () => {
      console.log("WebSocket Closed for",machineId);
    };

    setIsStreaming(true);
  };

  const stopStream = () => {
    if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
      wsRef.current.send(JSON.stringify({ type: "control", command: "stop", machineId }));
      wsRef.current.close();
      console.log("Stop signal sent for",machineId);
    }
    setIsStreaming(false);
  };

  useEffect(() => {
    return () => {
      if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
        wsRef.current.send(JSON.stringify({ type: "control", command: "stop", machineId }));
        wsRef.current.close();
      }
    };
  }, [machineId]);

  return (
    <Box
      sx={{
        width: "50%",
        minHeight: "80vh",
        p: isMobile ? 2 : 4,
        bgcolor: "#f9fafb",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 4,
        marginLeft:"150px"
      }}
    >
      <Paper
        elevation={3}
        sx={{
          width: "100%",
          maxWidth: 800,
          aspectRatio: "4/3",
          bgcolor: "#000",
          borderRadius: 2,
          overflow: "hidden",
        }}
      >
        <canvas
          ref={canvasRef}
          width={540}
          height={380}
          style={{ width: "100%", height: "100%" }}
        />
      </Paper>

      <Stack direction="row" spacing={2} justifyContent="center" flexWrap="wrap">
        <Button
          variant="contained"
          color="success"
          size="small"
          onClick={startStream}
          disabled={isStreaming}
        >
          Start Stream
        </Button>
        <Button
          variant="outlined"
          color="error"
          size="small"
          onClick={stopStream}
          disabled={!isStreaming}
        >
          Stop Stream
        </Button>
      </Stack>
    </Box>
  );
};

export default Layout;
